var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcClockGreyRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00012207,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.00012C14.0222 6.00012 12.0888 6.58661 10.4443 7.68543C8.79981 8.78424 7.51809 10.346 6.76121 12.1733C6.00433 14.0005 5.8063 16.0112 6.19215 17.951C6.578 19.8908 7.53041 21.6727 8.92894 23.0712C10.3275 24.4697 12.1093 25.4221 14.0491 25.808C15.9889 26.1938 17.9996 25.9958 19.8268 25.2389C21.6541 24.482 23.2159 23.2003 24.3147 21.5558C25.4135 19.9113 26 17.9779 26 16.0001C26 14.6869 25.7413 13.3865 25.2388 12.1733C24.7363 10.96 23.9997 9.85764 23.0711 8.92905C22.1425 8.00047 21.0401 7.26387 19.8268 6.76133C18.6136 6.25878 17.3132 6.00012 16 6.00012ZM17 17.0001C17 17.2653 16.8946 17.5197 16.7071 17.7072C16.5196 17.8948 16.2652 18.0001 16 18.0001H13C12.7348 18.0001 12.4804 17.8948 12.2929 17.7072C12.1054 17.5197 12 17.2653 12 17.0001C12 16.7349 12.1054 16.4806 12.2929 16.293C12.4804 16.1055 12.7348 16.0001 13 16.0001H15V13.0001C15 12.7349 15.1054 12.4806 15.2929 12.293C15.4804 12.1055 15.7348 12.0001 16 12.0001C16.2652 12.0001 16.5196 12.1055 16.7071 12.293C16.8946 12.4806 17 12.7349 17 13.0001V17.0001Z",
    fill: "#B5B5B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClockGreyRound);
export default __webpack_public_path__ + "static/media/ic-clock-grey-round.be8076e93143c5c6f037dc040d080406.svg";
export { ForwardRef as ReactComponent };